export const permissionFields = `
  permission
  value
`;

export const rolePermissionsFields = `
  roleId
  ${permissionFields}
`;
